import React from "react";
import RichText from "components/rich-text";
import Image from "components/image";
import ReviewsSnippet from "components/reviews-snippet";

const FlexibleHeaderImage = ({ data }) => {
	const { desktopImage, mobileImage, backgroundColor = "#fff", content } = data;

	return (
		<div
			className="w-full flex md:flex-row flex-col-reverse items-center justify-center"
			style={{ backgroundColor: backgroundColor.hex }}>
			<div className="w-full md:p-14 px-10 pt-2">
				<ReviewsSnippet
					className="!flex md:!justify-start !justify-center"
				/>
				<RichText value={content} />
			</div>
			<div className="w-full">
				<Image image={desktopImage} alt={desktopImage?.alt} className="md:!block !hidden" />
				<Image image={mobileImage} alt={mobileImage?.alt} className="md:!hidden !block" />
			</div>
		</div>
	);
};

export default FlexibleHeaderImage;